<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Consulta de documento
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Consulta</span>
      <span> /</span>
      <span>Documento</span>
    </p>
  </div>
</div>
<!-- Heading -->


<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="periodo"
              checked mdbInput />
          <label class="form-check-label" for="materialInline1">Periodo</label>
        </div>
      </div>
      <div class="col " style="max-width: 120px">
        <div class="md-form">
          <mdb-select label="Mes" [options]="optionsmes" placeholder="Mes" [filterEnabled]="true"></mdb-select>
        </div>
      </div>
      <div class="col" style="max-width: 120px">
        <div class="md-form">
          <mdb-select label="Año" [options]="optionsYear" placeholder="Año" [filterEnabled]="true"></mdb-select>
        </div>
      </div>
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="periodo"
             mdbInput />
          <label class="form-check-label" for="materialInline2">Rango</label>
        </div>
      </div>
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha inicio'" required
          formControlName='fechaInicio'>
        </mdb-date-picker>
      </div>
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <mdb-date-picker [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'" required formControlName='fechaFin'>
        </mdb-date-picker>
      </div>
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="tipoDoc"
              checked mdbInput />
          <label class="form-check-label" for="materialInline1">Todos</label>
        </div>
      </div>
      <div class="col d-flex align-items-center" style="max-width: 150px;">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="tipoDoc"
             checked mdbInput />
          <label class="form-check-label" for="materialInline1">Específico</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-select label="Tipo de documento" [options]="optionsTipoDoc" placeholder="Tipo de documento"
            [filterEnabled]="true"></mdb-select>
        </div>
      </div>
    </div>



  </div>

  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" color="secondary"  size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Detalle Documento</th>
            <th scope="col">Cantidad</th>
            <th scope="col">Monto Neto</th>
            <th scope="col">Monto Exento</th>
            <th scope="col">Imp.Adic</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>

        </tbody>
      </table>
    </div>
  </div>
</div>


<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Tipo</th>
            <th scope="col">Número</th>
            <th scope="col">Fecha</th>
            <th scope="col">CodVen</th>
            <th scope="col">Rut</th>
            <th scope="col">Detalle</th>
            <th scope="col">Comuna</th>
            <th scope="col">Monto-Ini</th>
            <th scope="col">Dcto.</th>
            <th scope="col">Total Neto</th>
            <th scope="col">Iva</th>
            <th scope="col">Total Bruto</th>
            <th scope="col">Orig</th>
            <th scope="col">CodRec</th>
            <th scope="col">Sucursal</th>
          </tr>
        </thead>
        <tbody>

        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" >
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Excel
    </button>
  </div>
</div>